import React from 'react'
import { ChartCard } from './AIChartParts'
import AIHorizontalBars from './AIHorizontalBars'
import { providerColor, providerLabel, num } from './aiCostFormat'

const AIProviderChart = ({ providers = [], isLoading, error }) => (
  <ChartCard title="Cost by Provider" isLoading={isLoading} error={error} isEmpty={!providers.length}>
    <AIHorizontalBars
      rows={providers.map((p) => ({
        label: providerLabel(p.provider),
        cost: p.cost,
        requests: p.requests,
        color: providerColor(p.provider),
        extra: [{ label: 'Audio minutes', value: num(p.audioMinutes, 1) }],
      }))}
    />
  </ChartCard>
)

export default AIProviderChart
